import { OcrResult } from "@finway-group/shared/lib/models"
import moment from "moment"
import React from "react"

import { getInvoiceTypeLabel } from "../utils/helpers"
import { EInvoiceDetails } from "./Details"
import { EInvoiceFooter } from "./Footer"
import { EInvoiceHeader } from "./Header"
import { EInvoiceItems } from "./Items"
import { EInvoiceNote } from "./Note"
import { EInvoicePaymentTerms } from "./PaymentTerms"
import { EInvoiceSummary } from "./Summary"
import { EInvoiceVatBreakdown } from "./VatBreakdown"

interface EInvoiceXmlRendererProps {
    data: OcrResult
}

export const EInvoiceXmlRenderer = ({ data }: EInvoiceXmlRendererProps) => {
    if (!data.eInvoiceData) {
        return null
    }

    const invoiceTypeCode = Number(data.eInvoiceData?.invoiceTypeCode)
    const invoiceTypeLabel = getInvoiceTypeLabel(invoiceTypeCode)
    const formattedDate = moment(data?.invoiceDate).format("DD.MM.YYYY")

    return (
        <div className="h-full w-full my-20 p-20">
            <div className="max-w-5xl mx-auto flex flex-col gap-20">
                <EInvoiceHeader invoiceTypeLabel={invoiceTypeLabel} invoiceTypeCode={invoiceTypeCode} invoiceNumber={data.invoiceNumber} invoiceDate={formattedDate} />
                <EInvoiceDetails data={data} />
                <EInvoiceItems data={data} />
                <EInvoiceVatBreakdown data={data} />
                <EInvoiceSummary data={data} />
                <EInvoicePaymentTerms data={data} />
                <EInvoiceNote data={data} />
                <EInvoiceFooter />
            </div>
        </div>
    )
}
